import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_API_URL } from 'src/api_urls'

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_API_URL,
  credentials: 'include',
})

export const apiSlice = createApi({
  baseQuery: baseQuery,
  endpoints: (builder) => ({}),
})
